module.exports = __webpack_public_path__ + "static/media/fr.f3a02ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/localised-handheld-phones/fr.png
// module id = 280
// module chunks = 0